import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\shubh\\OneDrive\\Desktop\\Documents\\MMI-FREELANCING\\NEW projects\\MMI-main\\app\\about\\about-client.tsx");
